import el from "@cypherpotato/el";
import { cond } from "../util";
import { Icon } from "./icon";
import { CopiableText } from "./text";
import { getUniqueColor } from "../ui/unique-color";
import { IconButton } from "./icon-button";
import { Button } from "./button";
import { copyToClipboard } from "../ui/clipboard";

export function ResourceBadge(resourceId, resourceType) {

    const icon = cond(
        [resourceType == "AiGateway", Icon("route-line")],
        [resourceType == "Collection", Icon("book-shelf-line")],
        [resourceType == "ChatClient", Icon("chat-1-line")],
        [resourceType == "ChatClientSession", Icon("chat-quote-line")],
        [resourceType == "ApiKey", Icon("key-2-line")],
        [true, Icon("align-item-bottom-line")]
    );

    const link = cond(
        [resourceType == "AiGateway", `/dashboard/gateways/${resourceId}`],
        [resourceType == "Collection", `/dashboard/collections/${resourceId}/documents`],
        [resourceType == "ChatClient", `/dashboard/chat-clients/${resourceId}`],
        [resourceType == "ChatClientSession", null],
        [resourceType == "ApiKey", null],
        [true, null],
    );

    const title = cond(
        [resourceType == "AiGateway", "Gateway"],
        [resourceType == "Collection", "Collection"],
        [resourceType == "ChatClient", "Chat Client"],
        [resourceType == "ChatClientSession", "Chat Client Session"],
        [resourceType == "ApiKey", "API Key"],
        [true, "Unknown"],
    );

    return el(".resource-badge",
        { style: { "--resource-color": getUniqueColor(resourceType) } },
        icon,
        el("span.title", title),
        el("span.id", '#' + resourceId.substr(-6)),
        el("span.buttons",
            Icon("file-copy-line", {
                onClick() {
                    copyToClipboard(resourceId)
                }
            }),
            link && Icon("external-link-line", {
                onClick() {
                    window.open(link, '_blank');
                }
            })
        )
    );
}